export default __webpack_public_path__ + "static/media/13.a24b6c20.png";